/**
 * Created by tomers on 7/23/2014.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var Loader = require("ui/loader/Loader");
    var template = require("manager-templates/categories/categoriesGridRowViewNewCategory.tmpl");
    var Checkbox = require("ui/checkbox/Checkbox");
    var InputField = require("ui/input-field/InputField");

    var CategoriesGridRowViewNewCategory = {};

    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {

        CategoriesGridRowViewNewCategory = Marionette.ItemView.extend({

            template: template,
            tagName: "tr",
            className: "campaign_row",
            loaders:[],
            ui:{
                order: ".ordering",
                name: ".name-input-container",
                proposedContainer: ".proposed-checkbox-container",
                assignedContent: ".assignedContent",
                assignedCampaigns: ".assignedCampaigns"
            },
            uiComponents:{
                selectCheckBox:{
                    type: Checkbox,
                    options:{
                        el: "view.ui.selector",
                        permutation: Checkbox.PERMUTATION.B,
                        label: "",
                        checked: false,
                        enabled: false
                    }
                },
                name: {
                    type: InputField,
                    options: {
                        permutation: InputField.Permutation.G,
                        el: "view.ui.name",
                        maxLength: "view.model.MAX_NAME_LENGTH",
                        placeholder: LE.translator.translate("LEManager.categories.list.categoryName.placeholder"),
                        autoFocus: true
                    },
                    events: {
                        onblur: "tryToSave",
                        enterPressed: "makeDummyBlur"
                    }
                },
                proposedCheckBox: {
                    type: Checkbox,
                    options:{
                        el: "view.ui.proposedContainer",
                        permutation: Checkbox.PERMUTATION.BIG,
                        label: "",
                        checked: false,
                        enabled: false
                    }
                }
            },

            initialize: function(options) {
                this.vent = options.vent;
                this.reqres = options.reqres;
            },

            onRender: function() {
                this.updateProposed();
            },

            updateProposed: function() {
                var proposed = this.model.get(this.model.KEYS.PROPOSED);
                this.uiComponents.proposedCheckBox.setCheckedState(proposed);
            },

            /**
             * IF the input is empty - the row should disappear, so we trigger the "cancel" event
             * @param componentId
             * @param eventName
             * @param data
             */
            tryToSave: function(componentId, eventName, data) {
                var value = (_.isString(data) ? data : data.value);
                if (_.isEmpty(value)) {
                    this.vent.trigger("categoryTableLayout:actions:new:cancel", this.model);
                }
                else {
                    this.vent.trigger("categoryTable:add", this, this.model, value);
                }
            },

            makeDummyBlur: function() {
                this.uiComponents.name.blurInput();
            },

            setError: function(attr, isError, msg) {
                if (attr === this.model.KEYS.NAME) {
                    this.uiComponents.name.setError(isError, msg);
                }
            },

            onSaveInvalid: function(model, errors) {
                if (_.has(errors, this.model.KEYS.NAME)) {
                    var errorMsg = LE.translator.translate(errors[this.model.KEYS.NAME]);
                    this.setError(this.model.KEYS.NAME, true, errorMsg);
                }
            },

            _getCategoryName: function() {
                return this.model.get(this.model.KEYS.NAME);
            },

            onError: function() {
                return true;
            }


        });

    });

    return CategoriesGridRowViewNewCategory;
});
